module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-regular.c79c0092.woff2";